export default function MinusIcon() {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
      <rect x="2.5" y="5.5" width="7" height="1" rx="0.5" fill="white" />
    </svg>
  );
}
